import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import TodoDashboard from "../Components/TodoDashboard/main";
// import { fetchWorkListPageData } from "../Redux/todos/actions";
// import { setToDoCount } from "../Redux/general/actions";
// import { markReadToDoItemsAPI } from "../Providers/main";
import Footer from "../Components/common/footer";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import { useWorklist } from "../Components/TodoDashboard/hook/useWorkList";

const WorkListPage = () => {
  // Redux
  const dispatch = useDispatch();
  // const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
  // const urlObj = new URL(backendUrl);
  // const isSecure = urlObj.protocol === "https:";
  // const wsProtocol = isSecure ? "wss:" : "ws:";
  // const wsHost = urlObj.host;
  // const wsUrl = `${wsProtocol}//${wsHost}/ws/todo/?username=${localStorage.getItem("username")}`;
  // const { lastMessage: lastMessageToDo } = useWebSocket(wsUrl, {
  //   share: false,
  //   shouldReconnect: () => true,
  // });

  // const workListData = useSelector((state) => state.todos);
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 3).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  // useEffect(() => {
  //   fetchWorkListPageData(dispatch);
  //   markReadToDoItemsAPI(dispatch, setToDoCount);
  // }, [dispatch]);
  // , lastMessageToDo]);

  useEffect(() => {
    fetchShakespeareStatus(caseId, 3, dispatch);
  }, [caseId, dispatch]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const [activeTab, setActiveTab] = useState("all");

  const { todos, todoTabs, loading, pageNo, hasNext, hasPrev, goNext, goPrev, refetch } =
    useWorklist(activeTab);
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container">
          <div className="top-panel-wrapper" />
          <NavBar flaggedPageName="3" />
          <div className="main-content cost-tb">
            <TodoDashboard
              pageObj={pageObject}
              todos={todos}
              todoTabs={todoTabs}
              loading={loading}
              pageNo={pageNo}
              hasNext={hasNext}
              hasPrev={hasPrev}
              goNext={goNext}
              goPrev={goPrev}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              workList={true}
              refetch={refetch}
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WorkListPage;
